import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import React from "react";
import { STRINGS } from "../strings";
import { translate } from "../translate";
import AnimatedModal from "./AnimatedModal";
import { AppButton } from "./Generic/AppButton";
import { default as AnimatedClockVector } from "/public/assets/person-looks-at-phone.svg?react";

interface Props {
  isOpen: boolean;
  onClickFinishOnboarding: () => void;
  onRequestClose: () => void;
}

const FinishOnboardingBeforeStaffingModal = (props: Props) => {
  const message = <p>{translate(STRINGS.WELL_BE_HAPPY_TO_ASSIGN_YOU_MESSAGE)}</p>;

  const actions = (
    <>
      <AppButton variant="filled" color="primary" onClick={props.onClickFinishOnboarding}>
        {translate(STRINGS.I_WANT_TO_FINISH_MY_ONBOARDING)}
      </AppButton>

      <AppButton variant="link" color="black" onClick={props.onRequestClose}>
        {translate(STRINGS.NOT_INTERESTED)}
      </AppButton>
    </>
  );

  const animation = (
    <FinishOnboardingBeforeStaffingModal.AnimationWrapper>
      <AnimatedClockVector />
    </FinishOnboardingBeforeStaffingModal.AnimationWrapper>
  );

  return (
    <FinishOnboardingBeforeStaffingModal.Styled
      headline={translate(STRINGS.DO_YOU_WANT_THIS_VISIT)}
      message={message}
      animation={animation}
      actions={actions}
      isOpen={props.isOpen}
      onRequestClose={props.onRequestClose}
    />
  );
};

FinishOnboardingBeforeStaffingModal.Styled = styled(AnimatedModal)`
  ${AnimatedModal.Headline} {
    text-align: start;
    font-size: 28px;
    max-width: 50vw;
  }

  ${AnimatedModal.Message} {
    > p {
      text-align: start;
      line-height: 150%;
    }
  }
`;

const patientMaleKeyframes = keyframes`
    0% { transform: translateY(-5px) }
    50% { transform: translateY(5px); }
    100% { transform: translateY(-5px); }
`;

const patientMaleKeyframes2 = keyframes`
    0% { transform: scale(0.8) }
    50% { transform: scale(1); }
    100% { transform: scale(0.8); }
`;

const patientFemaleKeyframes = keyframes`
    0% { transform: translateY(5px) }
    50% { transform: translateY(-5px) }
    100% { transform: translateY(5px) }
`;

const patientFemaleKeyframes2 = keyframes`
    0% { transform: scale(1); }
    50% { transform: scale(0.8) }
    100% { transform: scale(1); }
`;

const leftHandKeyframes = keyframes`
    0% { transform: rotate(-20deg) }
    50% { transform: rotate(-30deg) }
    100% { transform: rotate(-20deg) }
`;
const leftLegKeyframes = keyframes`
    0% { transform: rotate(-30deg); }
    25% { transform: rotate(-20deg); }
    50% { transform: rotate(-20deg); }
    85% { transform: rotate(-30deg); }
    100% { transform: rotate(-30deg); }
`;

FinishOnboardingBeforeStaffingModal.AnimationWrapper = styled.div`
  @media only screen and (min-width: 1024px) {
    display: none;
  }

  margin-top: -31.3vh;
  margin-bottom: -10vh;
  margin-left: 16vw;

  svg {
    height: 40vh;
    overflow: visible;

    [data-entity="patient-female"] {
      > path {
        animation: ${patientFemaleKeyframes2} 10s ease-in-out infinite;
        transform-origin: center top;
        opacity: 0.5;
      }

      [data-entity="face"] {
        animation: ${patientFemaleKeyframes} 10s ease-in-out infinite;
      }
    }

    [data-entity="patient-male"] {
      > path {
        animation: ${patientMaleKeyframes2} 10s ease-in-out infinite;
        transform-origin: center;
        opacity: 0.5;
      }

      [data-entity="face"] {
        animation: ${patientMaleKeyframes} 5s ease-in-out infinite;
      }
    }

    [data-entity="left-leg"] {
      animation: ${leftLegKeyframes} 7s ease-in-out infinite;
      transform-origin: 230px 235px;
    }

    [data-entity="left-hand"] {
      animation: ${leftHandKeyframes} 10s ease-in-out infinite;
      transform-origin: 240px 180px;
    }
  }
`;

export default FinishOnboardingBeforeStaffingModal;
